import { Component, Injector, OnInit, OnDestroy} from '@angular/core';
import { Unidad} from '../../../_models/unidad';
import { EstudioService} from '../estudio.service';
import { UnidadEtapasService} from './_services/unidad-etapas.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomAlertService} from '../../../_components/custom-alert/custom-alert.service';
import { ComentariosService} from '../../../_components/glm-comentarios/comentarios.service';

import {environment} from '../../../../environments/environment';
import { GLMLanguageService } from 'src/app/_services/glm-language.service';
import { Subscription } from 'rxjs';
import { GlobalService } from 'src/app/_services/global.service';
import { AccountService } from 'src/app/_services/account.service';
import { ThrobberService } from 'src/app/_services/throbber.service';

@Component({
  selector: 'unidad-etapas-barra',
  standalone: false,
  templateUrl: 'unidad-etapas-barra.component.html',
  styleUrls: ['unidad-etapas-barra.scss']
})

export class UnidadEtapasBarraComponent implements OnInit, OnDestroy {

  unidad: Unidad;

  materias: any = [];

  env: any = environment;

  comentariosObservable;
  idiomaDisplay;

  languageSubscription: Subscription;

  idiomas$;

  constructor(private injector: Injector,
              private langService: GLMLanguageService,
              private unidadEtapasService: UnidadEtapasService,
              private estudioService: EstudioService,
              private snackBarRef: MatSnackBar,
              private customAlertService: CustomAlertService,
              private comentariosService: ComentariosService,
              private globalService: GlobalService,
              private userService: AccountService,
              private throbberService: ThrobberService) {
    this.comentariosObservable = this.comentariosService.getComentariosObservable();
  }


  ngOnInit() {
    this.idiomas$ = this.globalService.idiomas$;
    this.langService.getLanguageObservable().subscribe(res => {
      this.idiomaDisplay = res.activeLang.nickName.toUpperCase();
    });
    this.unidad = this.injector.get('unidad');
    if (this.unidad.materias.length > 0) {
      this.extraerMaterias();
    }

    this.estudioService.getEstudioServiceObservable().subscribe(data => {
      if (!data) {
        return;
      }
      if (data.tipo === 'actualizar-unidad') {
        this.unidad = data.unidad;
        this.extraerMaterias();
      }
    });

    this.comentariosObservable.subscribe(data => {
      if (!data) {
        return;
      }
      if (data.accion === 'actualizar-cuenta') {
        if (data.tipo === 'unidad') {
          this.unidad.comentariosNuevos--;
        }
      }
    });
  }

  extraerMaterias() {
    this.materias = [];
    this.unidad.materias.map(materia => {
      this.materias.push(materia.nombreCompleto);
    });
  }

  marcarFavorita() {
    const modelo = {
      idOrigen: this.unidad.id,
      estado: !this.unidad.isFavorito
    };
    this.unidad.isFavorito = modelo.estado;
    this.estudioService.setUnidadFavorita(modelo).subscribe(() => {
      this.snackBarRef.open(
        `La unidad se ha ${modelo.estado ? 'marcado' : 'desmarcado'} como favorita.`,
        null,
        {duration: 2500}
      );
    }, (err) => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible ${modelo.estado ? 'marcar' : 'desmarcar'} la unidad como favorita. <br> ${err.error} <br> Código de error: ${err.statusText}`
      });
      this.unidad.isFavorito = !modelo.estado;
    });
  }

  setEstadoSuscripcion(estado) {
    const modelo = {targetID: this.unidad.id, tipo: 'unidad', estado};
    this.comentariosService.setEstadoSuscripcion(modelo).subscribe(() => {
      this.unidad.isNotificar = estado;
      this.snackBarRef.open(
        `Las notificaciones de la unidad han sido ${estado ? 'activadas' : 'desactivadas'}.`,
        null,
        {duration: 2500}
      );
    }, err => {
      this.customAlertService.setCustomMessage({
        tipo: 'error',
        texto: `No ha sido posible ${modelo.estado ? 'activar' : 'desactivar'} las notificacions de la unidad. <br> ${err.error} <br> Código de error: ${err.statusText}`
      });
    });
  }

  // Acciones del menú
  editar() {
    this.unidadEtapasService.emitAbrirModal(this.unidad.id, 'unidad');
  }

  verComentarios() {
    this.unidadEtapasService.emitAbrirModal(this.unidad.id, 'comentarios_unidad');
  }

  cambiarIdioma(idioma: string) {
    this.throbberService.setThrobberState(true);
    this.unidadEtapasService.setLanguage(idioma, this.unidad, this.userService.getUser().id).subscribe(
      res => {
        this.throbberService.setThrobberState(false);
        this.langService.setLanguage({nickName: idioma});
      },
      err => {
        this.throbberService.setThrobberState(false);
        this.customAlertService.setCustomMessage({
          tipo: 'error',
          texto: `No ha sido posible cambiar el idioma de la unidad. <br> ${err.error} <br> Código de error: ${err.statusText}`
        });
      }
    );
  }

  ngOnDestroy(): void {
    if (this.languageSubscription) {
      this.languageSubscription.unsubscribe();
    }
  }
}
